import { Text } from "@react-pdf/renderer";
import { useMemo } from "react";
import { formatDate } from "../../../../../_src_shared/utils/functions/formatDate";
import { formatPhone } from "../../../../../_src_shared/utils/functions/formatPhone";
import { formatSsn } from "../../../../../_src_shared/utils/functions/formatSsn";
import { formatDollar } from "../../../../../utils/numbers/formatDollar";
import { formatPercent } from "../../../../../utils/numbers/formatPercent";

const PdfValue = ({ children, type, style }) => {
  const value = useMemo(() => {
    if (type === "date") return formatDate(children);
    if (type === "phone") return formatPhone(children);
    if (type === "ssn") return formatSsn(children);
    if (type === "dollar") return formatDollar(children);
    if (type === "percent") return formatPercent(children);
    return children;
  }, [children, type]);

  const styles = useMemo(() => {
    return {
      fontSize: 9,
      color: "#000000",
      ...style,
    };
  }, [style]);
  return <Text style={styles}>{value || "-"}</Text>;
};

export default PdfValue;
